<div class="ScoreBox">

  <div class="ui grid">
    <div class="ui column leftCol" [ngStyle]="styles.leftArea">

      <div class="ui sixteen wide column header"
           *ngIf="this.tournamentsService._liveFixtureListFiltered">
        <headerTop (sportSelect)="sportSelected($event)"
                   [sportType]="'scoreBox_live_1'"
                   [onlyHeaderFor]="'live'"
                   [isScoreBox]=true></headerTop>
      </div>
      <div class="ui sixteen wide column ScrollBar"
           id="scrollableContainer"
           [ngStyle]="styles.rows">
        <liveFixtures [isScoreBox]=true [_bufferAmount]="3"></liveFixtures>

      </div>

      <preFixture [isScoreBox]=true></preFixture>

    </div>


    <div class="rightCol" id="SecondScreen_ScoreBox">
      <div class="p1">
        <div class="banner"   [ngStyle]="{'background': 'url(' + bannerUrl + ')'}">

        </div>
      </div>
      <div class="p2">
        <div class="headerTop scoreBox header">
          Heute Top Gewinner 
        </div>


        <table class="ui table rightItem"
               *ngFor="let win of winlist; let i = index">

          <tr>
            <td class="center aligned three wide" style="    padding: 3px;
    height: 61.5px;
    text-align: left
" rowspan="2">
            

              <span 
                    style="font-weight:bold; padding-left:20px; ">{{win.BranchName}}</span>
            </td>
            <td style="padding:3px;height:30px">
            
            </td>
            <td class="one wide"
                style="padding:3px;height:30px;text-align:right">
              {{win?.Amount | number : '1.2-2'}}€
            </td>
            <td class="one wide" style="padding:3px;height:30px">
              

            </td>

          </tr>
          <tr>
            <td style="border:0;padding:3px;height:30px">
            </td>
            <td style="    border: 0;
    padding: 3px;
    height: 30px;
    font-weight: bold;
    text-align: right;
    color: #14aa27;
    font-size: 22px;">
              {{win?.WinAmount | number : '1.2-2'}}€
            </td>
            
            <td style="border:0;padding:3px;height:30px;">

            </td>

          </tr>
        </table>

        <!--<table class="ui table rightItem"
         *ngFor="let scorebox of this.tournamentsService._ScoreboxList; let i = index">

    <tr>
      <td class="center aligned three wide" style="padding:3px;height:61.5px;" rowspan="2">
        <img *ngIf="scorebox.ScoreCardType == 4 || scorebox.ScoreCardType == 3" src="../../../Images/whistle.png" />
        <div style="height: 20px;font-size: 17px;color:black;overflow:hidden;margin-top:-3px;"
             *ngIf="scorebox.ScoreCardType == 4">
          <span style="font-weight:bold">{{"Ende" | t}}</span>
        </div>
        <div style="height: 20px;font-size: 17px;color:black;overflow:hidden;margin-top:-3px;"
             *ngIf="scorebox.ScoreCardType == 3">
          <span style="font-weight:bold">{{"HZ" | t}}</span>
        </div>

        <span *ngIf="scorebox.ScoreCardType != 4 && scorebox.ScoreCardType != 3"
              style="font-weight:bold">{{scorebox.MatchTime}}'</span>
      </td>
      <td style="padding:3px;height:30px">
        <span *ngIf="scorebox.ScoreCardType == 4  || scorebox.ScoreCardType == 3"
              style="padding:3px;height:30px;font-weight:bold">{{scorebox?.HomeTeam}}</span>
        <span *ngIf="scorebox.AffectedTeam == 2">{{scorebox?.HomeTeam}}</span>
        <span *ngIf="scorebox.AffectedTeam == 1" style="font-weight:bold;">{{scorebox?.HomeTeam}}</span>
      </td>
      <td *ngIf="scorebox.ScoreCardType == 2 && scorebox.AffectedTeam == 1 " class="one wide"
          style="padding:3px;height:30px;">
        {{scorebox?.HomeTeamScore}}
      </td>
      <td *ngIf="scorebox.ScoreCardType == 2 && scorebox.AffectedTeam == 2 " class="one wide"
          style="padding:3px;height:30px;">
        {{scorebox?.HomeTeamScore}}
      </td>
      <td *ngIf="scorebox.ScoreCardType == 1 && scorebox.AffectedTeam == 2 " class="one wide"
          style="padding:3px;height:30px;">
        {{scorebox?.HomeTeamScore}}
      </td>
      <td *ngIf="scorebox.ScoreCardType == 4  || scorebox.ScoreCardType == 3 " class="one wide"
          style="padding:3px;height:30px;font-weight:bold">
        {{scorebox?.HomeTeamScore}}
      </td>
      <td *ngIf="scorebox.ScoreCardType == 1 && scorebox.AffectedTeam == 1 " class="one wide"
          style="padding:3px;height:30px;font-weight:bold">
        {{scorebox?.HomeTeamScore}}
      </td>
      <td class="one wide" style="padding:3px;height:30px">
        <img class="ui mini image" *ngIf="scorebox.ScoreCardType == 1 && scorebox.AffectedTeam == 1"
             style="height:14px;width:14px" src="../../../Images/sport-icons/football.png" />
        <div *ngIf="scorebox.ScoreCardType == 2 && scorebox.AffectedTeam == 1" class="redcard"
             style="text-align:center;"></div>

      </td>

    </tr>
    <tr>
      <td style="border:0;padding:3px;height:30px">
        <span *ngIf="scorebox.ScoreCardType == 4  || scorebox.ScoreCardType == 3"
              style="padding:3px;height:30px;font-weight:bold">{{scorebox?.AwayTeam}}</span>
        <span *ngIf="scorebox.AffectedTeam == 1">{{scorebox?.AwayTeam}}</span>
        <span *ngIf="scorebox.AffectedTeam == 2" style="font-weight:bold;">{{scorebox?.AwayTeam}}</span>
      </td>
      <td *ngIf="scorebox.ScoreCardType == 4  || scorebox.ScoreCardType == 3"
          style="border:0;padding:3px;height:30px;font-weight:bold">
        {{scorebox?.AwayTeamScore}}
      </td>
      <td *ngIf="scorebox.ScoreCardType == 2 && scorebox.AffectedTeam == 1"
          style="border:0;padding:3px;height:30px;">
        {{scorebox?.AwayTeamScore}}
      </td>
      <td *ngIf="scorebox.ScoreCardType == 2 && scorebox.AffectedTeam == 2"
          style="border:0;padding:3px;height:30px;">
        {{scorebox?.AwayTeamScore}}
      </td>
      <td *ngIf="scorebox.ScoreCardType == 1 && scorebox.AffectedTeam == 1"
          style="border:0;padding:3px;height:30px;">
        {{scorebox?.AwayTeamScore}}
      </td>
      <td *ngIf="scorebox.ScoreCardType == 1 && scorebox.AffectedTeam == 2"
          style="border:0;padding:3px;height:30px;font-weight:bold">
        {{scorebox?.AwayTeamScore}}
      </td>
      <td style="border:0;padding:3px;height:30px;">
        <img class="ui mini image" *ngIf="scorebox.ScoreCardType == 1 && scorebox.AffectedTeam == 2"
             style="height:14px;width:14px" src="../../../Images/sport-icons/football.png" />
        <div *ngIf="scorebox.ScoreCardType == 2 && scorebox.AffectedTeam == 2" class="redcard"
             style="text-align:center;"></div>

      </td>

    </tr>
  </table>-->


      </div>
    </div>
  </div>

</div>

<div id="GoalModal" class="ui modal"
     style="position:absolute;left:10%;bottom:21% !important;width:1000px;background-color:rgba(255,255,255,0);">

  <div
    style="background-size: contain;width:100%;text-align:center;background-image: url('/Images/tor.png');background-repeat: no-repeat;height: 500px;background-position: center;background-color:rgba(0,0,0,0.4);">
    <span
      style="font-size: 135px; position: relative;top:300px;display:inline-block;color:black;text-shadow: 3px 3px 3px #ffffff">{{"Gol_Animation" | t}}</span>
    <!--<img src="../../../Images/goallogo.png" style="height:300px;" />-->
    <!--<img src="../../../Images/tor.png" style="height:470px;" />-->

  </div>

  <!--<div style="height:60px;width:100%;background-color:orange;font-size:25px;text-align:center"><span style="font-size: 30px;position: relative;top: 10px;" ></span></div>-->
  <div style="height: 100px;width:1000px;background-color: rgba(247, 187, 34, 1);font-size:25px;text-align:center;">
    <span style="font-size: 90px;position: relative;top: 32px;">{{this.goalteam}}</span></div>

</div>
<div id="RedCardModal" class="ui modal"
     style="position:absolute;bottom:0% !important;width:1371px;height:1064px;left:0;text-align:center;top:-11px;opacity:0.9 !important;background-color:rgba(0, 0, 0, 0.00);">

  <div style="width:100%;height:120px;text-align:center;background-color:red;position:absolute;top:177px;">
    <span style="font-size:90px;position:relative;top:35px;color:white">
      {{this.cardteam}}
    </span>

  </div>


  <div style="width:100%;text-align:center;position:absolute;bottom:0">

    <img src="../../../Images/redcardpopup.png" style="height:700px;"/>

  </div>


</div>
<!--<div id="RedCardModal" class="ui modal" [ngStyle]="{'width': (this.tournamentsService.Page_Window_Width - 507-39) + 'px','padding-top': '0px','padding-bottom': '0px','padding-left':'0px','padding-right': '5px','overflow':'hidden'}" style="position:absolute;bottom:0% !important;height:100%;left:0;text-align:center;top:0;opacity:0.9 !important;background-color:rgba(0, 0, 0, 0.00);">


    <div style="width:100%;height:90px;text-align:center;background-color:red">
        <span style="font-size:50px;position:relative;top:15px;color:white">
            {{this.cardteam}}
        </span>

    </div>


    <div style="width:100%;text-align:center;position:absolute;bottom:0">

        <img src="../../../Images/redcardpopup.png" style="height:700px;" />

    </div>


</div>-->


<div *ngIf="splashScreen" class="splashScreen {{splashScreenEffect ? 'trigerToFade' : ''}}">
  <img src="{{splashUrl}}" style="vertical-align: middle;width: 100%;height: 100%;" />
</div>
<comp_livetracker_modal></comp_livetracker_modal>
